import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import jwtAuthAxios from "services/jwtAuth";

export const searchHistoryKrs = createAsyncThunk("historyKrsMahasiswa/searchHistoryKrs", async (payload) => {
  let token = localStorage.getItem('auth_token');
  jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  const response = await jwtAuthAxios.post('/v1/mahasiswa/history-krs/search', payload);
  return response.data;
});

export const getHistoryKrsByNim = createAsyncThunk("historyKrsMahasiswa/getHistoryKrsByNim", async (nim) => {
  let token = localStorage.getItem('auth_token');
  jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  const response = await jwtAuthAxios.get(`/v1/mahasiswa/history-krs/${nim}`);
  return response.data;
});

const initialState = {
  loading: false,
  listHistoryKrs: []
}

const historyKrsMahasiswaSlice = createSlice({
  name: "historyKrsMahasiswa",
  initialState,
  reducers: {
    clearHistoryKrs: (state) => {
      state.listHistoryKrs = []
    }
  },
  extraReducers: (builder) => {
    builder
        .addCase(searchHistoryKrs.pending, (state) => {
          state.loading = true;
        })
        .addCase(searchHistoryKrs.fulfilled, (state, action) => {
          state.listHistoryKrs = action.payload
          state.loading = false;
        })
        .addCase(searchHistoryKrs.rejected, (state, action) => {
          state.loading = false;
          console.error("Error:", action.error);
        })
    builder
        .addCase(getHistoryKrsByNim.pending, (state) => {
          state.loading = true;
        })
        .addCase(getHistoryKrsByNim.fulfilled, (state, action) => {
          state.listHistoryKrs = action.payload
          state.loading = false;
        })
        .addCase(getHistoryKrsByNim.rejected, (state, action) => {
          state.loading = false;
          console.error("Error:", action.error);
        })
  }
})

export const { clearHistoryKrs } = historyKrsMahasiswaSlice.actions;
export const historyKrsMahasiswaSelector = (state) => state.historyKrsMahasiswa;
export default historyKrsMahasiswaSlice.reducer;
